import React from 'react';
import type { CaTaxImplicationsResult } from '@capintel/instruments-lib';

import ImplicationsSection from './TaxAnalysisImplicationsSections';
import { getCaImplicationsRows } from './utils/getCaImplicationsRows';

type CaTaxImplicationsTableProps = {
  taxImplications: CaTaxImplicationsResult;
};

const CaTaxImplicationsTable: React.FC<CaTaxImplicationsTableProps> = ({ taxImplications }) => {
  const rows = getCaImplicationsRows();

  return <ImplicationsSection rows={rows} taxAnalysisData={taxImplications} />;
};

export default CaTaxImplicationsTable;
